import * as THREE from "three";
import Visualization from "./Visualization";
import React, { useEffect, useRef } from "react";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { InteractionManager } from "three.interactive";

export const FS3D = ({
  index,
  totalLength,
  totalWidth,
  totalThickness,
  FS,
  BLK,
  setIsOpen
}) => {
  const refContainer = useRef(null);
  const [mode, setMode] = React.useState("free");
  const totalArea = (totalLength * totalThickness) / Math.pow(10, 6);
  const [UnCoveredArea, setUnCoveredArea] = React.useState(0);
  const createFS = (length, thickness, width, resizeFactor, x, y, z, scene) => {
    var FSGeometry = new THREE.BoxGeometry(
      resizeFactor * length,
      resizeFactor * thickness,
      resizeFactor * width
    );

    
    var FSmaterial = new THREE.MeshPhongMaterial({
      color: "#0066ff",
      side: THREE.DoubleSide
    });
    var FSEdges = new THREE.EdgesGeometry(FSGeometry);
    var FSedgesMaterial = new THREE.LineBasicMaterial({
      color: 0x000000,
      side: THREE.DoubleSide
    });
    var FSLines = new THREE.LineSegments(FSEdges, FSedgesMaterial);
    var FS = new THREE.Mesh(FSGeometry, FSmaterial);
    FS.position.x = (resizeFactor * length) / 2 + 0.02 + x;
    FS.position.y = (resizeFactor * thickness) / 2 + 0.02 + y;
    FS.position.z = (resizeFactor * width) / 2 + 0.02 + z;
    scene.add(FS);
    FS.add(FSLines);
  };
  const createBLK = (
    length,
    thickness,
    width,
    resizeFactor,
    x,
    y,
    z,
    scene
  ) => {
    var BLKGeometry = new THREE.BoxGeometry(
      resizeFactor * length,
      resizeFactor * thickness,
      resizeFactor * width
    );
    var BLKmaterial = new THREE.MeshPhongMaterial({
      color: "#ff9900",
      side: THREE.DoubleSide
    });
    var BLKEdges = new THREE.EdgesGeometry(BLKGeometry);
    var BLKedgesMaterial = new THREE.LineBasicMaterial({
      color: 0x000000,
      depthTest: true
    });
    var BLKLines = new THREE.LineSegments(BLKEdges, BLKedgesMaterial);
    var BLK = new THREE.Mesh(BLKGeometry, BLKmaterial);
    BLK.position.x = (resizeFactor * length) / 2 + 0.02 + x;
    BLK.position.y = (resizeFactor * thickness) / 2 + 0.02 + y;
    BLK.position.z = (resizeFactor * width) / 2 + 0.02 + z;
    scene?.add(BLK);
    BLK.add(BLKLines);
  };
  useEffect(() => {
    if (FS) {
      localStorage.setItem("FSData", JSON.stringify(FS));
    }
  }, [FS]);

  // Retrieve FS data from localStorage on component mount
  useEffect(() => {
    const storedFS = localStorage.getItem("FSData");
    if (storedFS) {
   //   FS=storedFS;
      console.log("Retrieved FS data:", JSON.parse(storedFS));
    }
  }, []);
  useEffect(() => {
    const drawElements=(profile='LP',totalLength,resizeFactor,totalWidth,FS,totalArea,scene)=>{
      let [tempLength,tempWidth,tempThickness,tempFS,area,prevDimensions,maxThickness]=[totalLength,totalWidth,totalThickness,FS&& JSON.parse(JSON.stringify(FS)),totalLength*totalThickness,[0,0,0],0];
if(tempFS?.length>0)
{
 for(const element of tempFS){

          [tempLength,tempWidth,tempThickness,area,prevDimensions,maxThickness]= ElementdrawHelper(element.itemType=="BLK"?createBLK:createFS,tempLength,tempWidth,tempThickness,prevDimensions,maxThickness,resizeFactor,element,totalArea,scene);

      }
}
     
      setUnCoveredArea(area);

     };
  /**
   * The ElementdrawHelper function helps to create elements in a scene based on specified dimensions and
   * available area.
   * @returns The function `ElementdrawHelper` is returning an array containing the updated values of
   * `tempLength`, `tempWidth`, `tempThickness`, and `area`.
   */
  const ElementdrawHelper=(drawer,tempLength,tempWidth,tempThickness,prevDimensions,maxThickness,resizeFactor,element,area,scene)=>{

    if(tempWidth-prevDimensions>=element.width && tempLength>=element.length){
      // to handle two cases where the element can be placed in the scene

      drawer(
        element.length,
         element.width,
       element.thickness,
           resizeFactor,
            (totalLength - tempLength) * resizeFactor,
            (totalWidth - tempWidth) * resizeFactor,
            (totalThickness - tempThickness) * resizeFactor,
          scene
);




        tempWidth-=element.width;

    }
    else if (tempLength-prevDimensions[0]>=element.length ){
     // if the width is not enough to place the element,
     // then reduce the length and place the element in the scene
     maxThickness=Math.max(maxThickness,element.thickness);
     tempLength-=prevDimensions[0];
     tempWidth=totalWidth;
        drawer(
                       element.length,
                        element.width,
                      element.thickness,
                          resizeFactor,
                           (totalLength - tempLength) * resizeFactor,
                           (totalWidth - tempWidth) * resizeFactor,
                           (totalThickness - tempThickness) * resizeFactor,
                         scene
          );



    }
    else if (tempThickness-prevDimensions[2]>=element.thickness ) {
      tempThickness-=maxThickness;
      tempLength=totalLength;
      tempWidth=totalWidth;
      maxThickness=element.thickness;

        drawer(
          element.length,
           element.width,
         element.thickness,
             resizeFactor,
              (totalLength - tempLength) * resizeFactor,
              (totalWidth - tempWidth) * resizeFactor,
              (totalThickness - tempThickness) * resizeFactor,
            scene
);



    }
    area-=(element.length*element.thickness)/Math.pow(10,6);
    return [tempLength,tempWidth,tempThickness,area,[element.length,element.width,element.thickness],maxThickness];
   }
      // === THREE.JS CODE START ===
      const  scene = new THREE.Scene();
      const  camera = new THREE.PerspectiveCamera(
        60,
        window.innerWidth / window.innerHeight,
        0.1,
        500
      );
      var renderer = new THREE.WebGLRenderer({antialias:true});
      renderer.setSize(1000, 560);
      renderer.setClearColor(0xffffff);
      while(refContainer.current?.children?.length>0){
        refContainer.current.removeChild(refContainer.current.firstChild);
     }
        refContainer.current?.appendChild(renderer.domElement);

      var axesHelper = new THREE.AxesHelper(5);
      // scene.add(axesHelper);

      const orbit = new OrbitControls(camera, renderer.domElement);
      const resizeFactor = 0.001;
      camera.position.z = 7;
      camera.position.y = 3;
      camera.position.x = 2;
      orbit.update();

      let tempThciness = totalThickness;
      let tempWidth = totalWidth;
      let tempLength = totalLength;
      const Dimensions = {
      'length':'partLot_Length_c',
      'width':'partLot_Width_c',
      'thickness':'partLot_Depth_c'

      }

    //  const DrawFSAndBLK = (profile = "LP") => {

    //     let [
    //       templength,
    //       tempwidth,
    //       tempThickness,
    //       i,
    //       j,
    //       k,
    //       tempFS,
    //       tempBLK,
    //       MaxInRow,
    //       MinInRow
    //     ] = [
    //       totalLength,
    //       totalWidth,
    //       totalThickness,
    //       0,
    //       0,
    //       0,
    //      FS&& JSON.parse(JSON.stringify(FS)),
    //       BLK&&JSON.parse(JSON.stringify(BLK)),
    //      FS?.length>0&& FS[0].length,
    //      FS?.length>0&&  FS[0].length
    //     ];

    //     let temp = 0;
    //     let maxThicknesInLengthRow = 0;

    //     while (tempThickness > 0 && tempFS?.length > 0) {
    //       row = 0;
    //       templength = totalLength;

    //       if (FS?.length != tempFS?.length) tempThickness -= maxThicknesInLengthRow;
    //       maxThicknesInLengthRow = 0;
    //       while (templength >= tempFS[0]?.length && tempFS?.length > 0) {
    //         tempwidth = totalWidth;
    //         let maxLengthInWidthRow = 0;

    //       ;
    //         temp +=
    //           (tempFS[0]?.length * tempFS[0]?.thickness) / Math.pow(10, 6);
    //         while (tempwidth>0  && tempFS.length > 0) {

    //           if (tempFS.length > 0) {
    //             if (tempThickness - tempFS[0].thickness > tempFS[0].thickness) {
    //               MaxInRow = Math.max(MaxInRow, tempFS[0].thickness);
    //               MinInRow = Math.min(MinInRow, tempFS[0].thickness);
    //             }
    //             if(tempLength>0 && tempThciness>0 && tempwidth>0){
    //             if (tempFS[0].itemType === "BLK") {
    //               createBLK(
    //                 tempFS[0].length,
    //                 tempFS[0].width,
    //                 tempFS[0].thickness,
    //                 resizeFactor,
    //                 (totalLength - templength) * resizeFactor,
    //                 (totalWidth - tempwidth) * resizeFactor,
    //                 (totalThickness - tempThickness) * resizeFactor,
    //                 scene
    //               );
    //             } else {
    //               createFS(
    //                 tempFS[0].length,
    //                 tempFS[0].width,
    //                 tempFS[0].thickness,
    //                 resizeFactor,
    //                 (totalLength - templength) * resizeFactor,
    //                 (totalWidth - tempwidth) * resizeFactor,
    //                 (totalThickness - tempThickness) * resizeFactor,
    //                 scene
    //               );
    //             }} else{
    //               break;
    //             }
    //             if (tempFS[0].itemType === "BLK") {
    //               tempwidth -= tempFS[0].width;
    //             } else {
    //               tempwidth -= tempFS[0].width;
    //             }

    //             if (tempwidth <= tempFS[0].width) {


    //               if (tempFS[0].itemType === "BLK") {
    //                 templength -= tempFS[0].length;
    //               } else {
    //                 templength -= tempFS[0].length;

    //               }

    //             }
    //           }
    //           maxThicknesInLengthRow = Math.max(tempFS[0].thickness, maxThicknesInLengthRow);
    //           maxLengthInWidthRow = Math.max(tempFS[0].length, maxLengthInWidthRow);
    //           tempFS.shift();
    //         }

    //       }
    //     }
    //     setUnCoveredArea(totalArea - temp);
    //   };

    //  DrawFSAndBLK();
    drawElements('FS',totalLength,resizeFactor,totalWidth,FS,totalArea,scene);

      var cubeGeometry = new THREE.BoxGeometry(
        resizeFactor * totalLength + 0.2,
        0.1,
        resizeFactor * totalThickness + 0.2
      );
      var material = new THREE.MeshPhongMaterial({
        color: "gray",
        side: THREE.DoubleSide
      });
      var base = new THREE.Mesh(cubeGeometry, material);

      base.position.x = (resizeFactor * totalLength) / 2;
      base.position.y = 0.05;
      base.position.z = (resizeFactor * totalThickness) / 2;
      base.updateMatrixWorld();
      base.name = "base";
      scene.add(base);

      // Add edges for the base
      var rightSide = new THREE.BoxGeometry(
        resizeFactor * totalLength + 0.2,
        resizeFactor * totalWidth,
        0.1
      );
      var right = new THREE.Mesh(rightSide, material);
      right.position.x = (resizeFactor * totalLength) / 2;
      right.position.y = (resizeFactor * totalWidth) / 2;
      right.position.z = -0.1;
      scene.add(right);

      var leftSide = new THREE.BoxGeometry(
        resizeFactor * totalLength + 0.2,
        resizeFactor * totalWidth,
        0.1
      );
      var left = new THREE.Mesh(leftSide, material);
      left.position.x = (resizeFactor * totalLength) / 2;
      left.position.y = (resizeFactor * totalWidth) / 2;
      left.position.z = resizeFactor * totalThickness + 0.1;
      scene.add(left);

      var topGeometry = new THREE.BoxGeometry(
        0.1,
        resizeFactor * totalWidth,
        resizeFactor * totalThickness + 0.3
      );
      var top = new THREE.Mesh(topGeometry, material);
      top.position.x = -0.05;
      top.position.y = (resizeFactor * totalWidth) / 2;
      top.position.z = (resizeFactor * totalThickness) / 2;
      scene.add(top);

      var botGeometry = new THREE.BoxGeometry(
        0.1,
        resizeFactor * totalWidth,
        resizeFactor * totalThickness + 0.3
      );
      var bot = new THREE.Mesh(botGeometry, material);
      bot.position.x = 0.1 + resizeFactor * totalLength;
      bot.position.y = (resizeFactor * totalWidth) / 2;
      bot.position.z = (resizeFactor * totalThickness) / 2;
      scene.add(bot);

      var edgesMaterial = new THREE.LineBasicMaterial({
        color: 0x000000,
        depthTest: true,
        side: THREE.DoubleSide
      });

      // Lighting
      const color = 0xffffff;
      const intensity = 4;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(4, 4, 4);
      scene.add(light);

      const light2 = light.clone();
      light2.position.set(-4, -4, -4);
      scene.add(light2);

      const light3 = light.clone();
      light3.position.set(10, 8, 0);
      light3.intensity = 0;
      scene.add(light3);

      const light4 = light.clone();
      light4.position.set(-10, -8, 0);
      scene.add(light4);

      // Add a directional light to the scene
      const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
      directionalLight.position.set(0, 1, 0);
      scene.add(directionalLight);

      // Animation loop
      var animate = function () {
        requestAnimationFrame(animate);
        renderer.render(scene, camera);
      };
      const raycaster = new THREE.Raycaster();
      const mouse = new THREE.Vector2();
      let intersects = [];
      if (mode === "top") {
        camera.position.z = 6;
        camera.position.y = 0;
        camera.position.x = 0;
        scene.position.y = -0.5;
        scene.position.x = -4;
        scene.position.z = 3;
        scene.rotation.x = 1.35;
        scene.rotation.y = 0.05;
        scene.rotation.z = -0.3;
        orbit.enabled = false;
        scene.updateMatrixWorld();
        raycaster.intersectObjects(scene.children);
        raycaster.setFromCamera(mouse, camera);
        const onClick = (event) => {
          // Calculate mouse position in normalized device coordinates (-1 to +1)
          mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
          mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

          // Update the raycaster with the camera and mouse position
          raycaster.setFromCamera(mouse, camera);

          // Calculate objects intersecting the picking ray
          intersects = raycaster.intersectObjects(scene.children);
          console.log(intersects);
          // Check if the base was clicked
          if (intersects.length > 0 && intersects[0]?.object?.name == "base") {
            setIsOpen(true); // Handle click on the base
          }
        };

        // Attach event listener to the renderer's DOM element
        renderer.domElement.addEventListener("click", onClick);
      }

      // Event listener for clicks

      animate();

      // Adding click event to base

      const handleResize = () => {
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(window.innerWidth, window.innerHeight);
      };
      window.addEventListener("resize", handleResize);

      // Clean up on component unmount
      return () => {
        window.removeEventListener("resize", handleResize);
        if (refContainer.current) {
          refContainer.current.removeChild(renderer.domElement);
        }
      };
      // === THREE.JS CODE END ===

  }, [createBLK, createFS, mode ]);

  return (
    <>
      <div
        className="table-bg  p-4 mt-3 m-1 "
        style={{
          paddingTop: "20%"
        }}
      >
        <div className="d-flex justify-content-between  ">
          <h3>3D Visalizaion</h3>
          <div className="legend">

            <div>
              <div
                style={{
                  background: "#ff9900",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  display: "inline-block",
                  margin: "0.1em"
                }}
              ></div>
              <span>BLK</span>
            </div>
            <div>
              <div
                style={{
                  background: "#0066ff",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  display: "inline-block",
                  margin: "0.1em"
                }}
              ></div>
              <span>FS</span>
            </div>
            <div>
              <span
                style={{
                  fontSize: "1em",
                  display: "inline-block",
                  marginLeft: "0.45em"
                }}
              >
                <strong>Total Area:</strong>
              </span>   
              <span>{` ` + totalArea}</span>
            </div>
            <div>
              <span
                style={{
                  fontSize: "1em",
                  display: "inline-block",
                  marginLeft: "0.45em"
                }}
              >
                
              </span>
             {/* <strong>Empty Space:</strong>
              <span>{` ` + UnCoveredArea.toFixed(3)}</span>*/}
            </div>
            {/* {UnCoveredArea.toFixed(1)>0&&(
            <button className="submit-btn ro d-block m-2 rounded  "
            style={{
              padding: "0.5em",
              fontSize: "1em",
              color: "white",
              width: "fit-content"
            }}onClick={() => setIsOpen(true)}>
            fill Empty space
            </button>)
            } */}
          </div>
          <select
            className="form-select"
            style={{
              maxWidth: "200px",
              padding: "0.5em",
              marginBottom: "10px"
            }}
            defaultValue={"free"}
            onChange={(e) => setMode(e.target.value)}
          >
            <option value="free">Free Rotation </option>
            <option value="top">Top View</option>
          </select>
        </div>

        <div className="vis-container">
          <div ref={refContainer}></div>
        </div>
      </div>
    </>
  );
};
